import React, { useEffect, useRef, Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { captureInboundReferral } from '../components/useReferral';
import { trackSignupClick, withAnalyticsParams } from '../lib/analytics';
// ROUTE: /r/:code — the destination of a shared waitlist invite link.
// It records the inbound referral code, then forwards the visitor into the
// waitlist flow with the code attached so the modal can credit the referrer
// and show an "<code> invited you" banner.
export function ReferralCapture() {
  const {
    code
  } = useParams<{
    code: string;
  }>();
  const navigate = useNavigate();
  useEffect(() => {
    const clean = (code ?? '').trim().toLowerCase();
    if (clean) {
      captureInboundReferral(clean);
      trackSignupClick('referral-capture', 'Referral signup');
      window.location.href = withAnalyticsParams(`https://app.getgiga.com/signup?ref=${encodeURIComponent(clean)}`);
    } else {
      trackSignupClick('referral-capture', 'Referral signup');
      window.location.href = withAnalyticsParams('https://app.getgiga.com/signup');
    }
  }, [code]);
  // Brief, on-brand interstitial while we redirect into the waitlist.
  return <div className="min-h-screen w-full flex items-center justify-center bg-[#FBF9F5] text-[#2B211A]" data-id="element-11384" data-mp="1bnzyq3ro0rey">
      <div className="flex flex-col items-center gap-4" data-id="element-11385" data-mp="17lwjd41vl2oe">
        <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gradient-to-b from-[#F97316] to-[#EA580C] shadow-[0_8px_24px_rgba(234,88,12,0.4)]" data-id="element-11386" data-mp="17oiqj2kutg63">
          <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/c9cswf4udjck7zyoebqqwd/63a18a4c-5d20-4ad2-ba5f-9334c775fe47/Vector.png" alt="Giga" className="w-6 h-6 object-contain [filter:brightness(0)_invert(1)]" data-id="element-11387" data-mp="1gmb86de1szwn" />
          
        </span>
        <p className="text-sm font-medium text-[#6B5D52]" data-id="element-11388" data-mp="24bnglb1jx3xw">
          Opening your invite…
        </p>
      </div>
    </div>;
}